export const handleWindow = (): any => {
  const win =
    typeof window !== 'undefined'
      ? window
      : {
          navigator: {
            userAgent: '',
          },
          location: {
            hash: '',
            host: '',
            hostname: '',
            href: '',
            origin: '',
            pathname: '',
            protocol: '',
            search: '',
          },
          document: {
            referer: '',
          },
          open: () => {},
        };
  return win;
};

export const getRandomKey = () => Math.random().toString(36).slice(-8);

export const addItemsToArray = <T>(
  originArray: T[],
  targetIndex: number,
  deleteCount: number,
  addItems: T[]
): T[] => {
  const newArr = [...originArray];
  newArr.splice(targetIndex, deleteCount, ...addItems);
  return newArr;
};

/* 节流 */
export const throttle = (func: (...args: any[]) => void, delay: number) => {
  let lastTime = 0;
  return function (...args: any[]) {
    const now = new Date().getTime();
    if (now - lastTime < delay) {
      return;
    }
    lastTime = now;
    return func(...args);
  };
};

/*
  防抖
  immediate：可选参数，如果为 true，则在第一次触发事件时立即执行函数，而在后续的触发事件中延迟执行
*/
export const debounce = (
  func: (...args: any[]) => void,
  wait: number,
  immediate?: boolean
) => {
  let timeoutId: NodeJS.Timeout | undefined;
  return function (...args: any[]) {
    const later = () => {
      timeoutId = undefined;
      func(...args);
      if (!immediate) {
      }
    };
    const callNow = immediate && !timeoutId;
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(later, wait);
    if (callNow) {
      func(...args);
    }
  };
};